const fnameElement = document.getElementById("primary-first-name");
const fname = new CustomFormValidation(fnameElement, fnameElement.parentElement.querySelector(".form-group__msg"));

const lnameElement = document.getElementById("primary-last-name");
const lname = new CustomFormValidation(lnameElement, lnameElement.parentElement.querySelector(".form-group__msg"));

const primeEmailElement = document.getElementById("primary-email");
const primeEmail = new CustomFormValidation(primeEmailElement, primeEmailElement.parentElement.querySelector(".form-group__msg"));

const passwordElement = document.getElementById("password");
const password = new CustomFormValidation(passwordElement, passwordElement.parentElement.querySelector(".form-group__msg"));

const addressElement = document.getElementById("street-address");
const address = new CustomFormValidation(addressElement, addressElement.parentElement.querySelector(".form-group__msg"));

const primePhoneNumberElement = document.getElementById("primary-phone-number");
const primePhoneNumber = new CustomFormValidation(primePhoneNumberElement, primePhoneNumberElement.parentElement.querySelector(".form-group__msg"));

const secondFnameElement = document.getElementById("secondary-first-name");
const secondFname = new CustomFormValidation(secondFnameElement, secondFnameElement.parentElement.querySelector(".form-group__msg"));

const secondLnameElement = document.getElementById("secondary-last-name");
const secondLname = new CustomFormValidation(secondLnameElement, secondLnameElement.parentElement.querySelector(".form-group__msg"));

const secondEmailElement = document.getElementById("secondary-email");
const secondEmail = new CustomFormValidation(secondEmailElement, secondEmailElement.parentElement.querySelector(".form-group__msg"));

const secondPhoneNumberElement = document.getElementById("secondary-phone-number");
const secondPhoneNumber = new CustomFormValidation(secondPhoneNumberElement, secondPhoneNumberElement.parentElement.querySelector(".form-group__msg"));

document.querySelectorAll(".form-section input[type='text'], input[type='password'], input[type='tel']").forEach((element) => {
  if (element.id === "primary-phone-number") {
    numberCheck(primePhoneNumber);
  } else if (element.id === "secondary-first-name") {
    firstNameCheck(secondFname);
  } else if (element.id === "secondary-last-name") {
    lastNameCheck(secondLname);
  } else if (element.id === "secondary-email") {
    emailCheck(secondEmail);
  } else if (element.id === "secondary-phone-number") {
    numberCheck(secondPhoneNumber);
  }
});

function runCheck(event) {
  let e = event.target;
  if (e.id === "primary-first-name") {
    firstNameCheck(fname);
  } else if (e.id === "primary-last-name") {
    lastNameCheck(lname);
  } else if (e.id === "primary-email") {
    emailCheck(primeEmail);
  } else if (e.id === "password") {
    passwordCheck(password);
  } else if (e.id === "street-address") {
    addressCheck(address);
  } else if (e.id === "primary-phone-number") {
    formatPhoneText(event);
    numberCheck(primePhoneNumber);
  } else if (e.id === "secondary-first-name") {
    firstNameCheck(secondFname);
  } else if (e.id === "secondary-last-name") {
    lastNameCheck(secondLname);
  } else if (e.id === "secondary-email") {
    emailCheck(secondEmail);
  } else if (e.id === "secondary-phone-number") {
    formatPhoneText(event);
    numberCheck(secondPhoneNumber);
  }
}

function allValid() {
  return fname.getValid && lname.getValid && primeEmail.getValid && password.getValid && address.getValid && primePhoneNumber.getValid && secondFname.getValid && secondLname.getValid && secondEmail.getValid && secondPhoneNumber.getValid;
}

let submitBtn = document.getElementById("submit");

function disableSubmit() {
  if (!allValid()) {
    submitBtn.setAttribute("disabled", true);
  } else {
    submitBtn.removeAttribute("disabled");
  }
}

disableSubmit();

document.addEventListener("keydown", (event) => {
  let e = event.target;
  if (e.id === "primary-phone-number") {
    enforceFormat(event);
  } else if (e.id === "secondary-phone-number") {
    enforceFormat(event);
  }
});

document.addEventListener("input", (event) => {
  runCheck(event);
}, true);

document.addEventListener("blur", (event) => {
  runCheck(event);
}, true);

document.addEventListener("keyup", (event) => {
  runCheck(event);
  disableSubmit();
}, true);

let childrenContainer = document.querySelector(".children-container");
let children = document.querySelectorAll(".children-group");
let removeChild = document.getElementById("remove-child-button");
let addChild = document.getElementById("add-child-button");
let childDelete = document.querySelector('input[name="child-delete"]');
let childId;

if (children.length === 0) {
  removeChild.setAttribute("disabled", true);
} else if (removeChild.hasAttribute("disabled")) {
  removeChild.removeAttribute("disabled");
}

if (children.length === 8) {
  addChild.setAttribute("disabled", true);
} else if (addChild.hasAttribute("disabled")) {
  addChild.removeAttribute("disabled");
}

let i = children.length;
let html;
document.addEventListener("click", function (event) {
  if (event.target.id === "add-child-button") {
    if (i < 8) {
      i++;
      html = `
        <div class="form-group children-group">
          <h4 class="children-group__child-number">Child ${i}</h4>
          <label class="form-group__label children-group__label" for="child-${i}-name">Child ${i} Name</label>
          <input class="form-group__input children-group__input" type="text" id="child-${i}-name" name="child-${i}-name">
          <label class="form-group__label children-group__label" for="child-${i}-birth">Child ${i} Birthday</label>
          <input class="form-group__input children-group__input date-picker-input" type="text" id="child-${i}-birth" name="child-${i}-birth" readonly>
        </div>
        <input type="hidden" name="child-${i}-id" value="">
    `;
      childrenContainer.insertAdjacentHTML("beforeend", html);
      children = document.querySelectorAll(".children-group");
    }
  }

  if (event.target.id === "remove-child-button") {
    if (i > 0) {
      children = document.querySelectorAll(".children-group");
      if (children[i - 1].querySelector(".child-id") !== null && children[i - 1].querySelector(".child-id").value !== "") {
        childId = children[i - 1].querySelector(".child-id").value;
        if (childDelete.value === "") {
          childDelete.value = childId
        } else {
          childDelete.value = childDelete.value + " " + childId;
        }
        childDelete = document.querySelector('input[name="child-delete"]');
      }
      children[i - 1].remove();
      i--;
    }
  }

  if (event.target.id === "add-child-button" || event.target.id === "remove-child-button") {
    if (i === 0) {
      removeChild.setAttribute("disabled", true);
    } else if (removeChild.hasAttribute("disabled")) {
      removeChild.removeAttribute("disabled");
    }

    if (i === 8) {
      addChild.setAttribute("disabled", true);
    } else if (addChild.hasAttribute("disabled")) {
      addChild.removeAttribute("disabled");
    }
  }
});